import React from "react";

const ButtonLoader = () => {
  return (
    <div className="button-loader">
      <div className="spinner"></div>
    </div>
  );
};

export default ButtonLoader;